import { c as _c } from "react/compiler-runtime";
import { type FocusEvent, useEffect, useEffectEvent, useRef } from 'react';

/** Focus handlers for a control that can go while focused, which hand focus to `onRemovedWhileFocused` when it does. */
const useRefocusOnRemoval = onRemovedWhileFocused => {
  const $ = _c(4);
  const isFocusedRef = useRef(false);
  const moveFocus = useEffectEvent(onRemovedWhileFocused);
  let t0;
  if ($[0] !== moveFocus) {
    t0 = () => () => {
      if (isFocusedRef.current) {
        moveFocus();
      }
    };
    $[0] = moveFocus;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      onFocus: () => {
        isFocusedRef.current = true;
      },
      onBlur: event => {
        if (event.relatedTarget) {
          isFocusedRef.current = false;
        }
      }
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default useRefocusOnRemoval;